import { LogoutService } from '@/api/services/Authentication/Logout';
import { useServiceInstance } from '@/hooks/useServiceInstance';

import { useServiceMethod } from '../useServiceMethod';

export function useLogout() {
  const service = useServiceInstance(LogoutService);
  return useServiceMethod(service.execute);
}
